import React, { createContext } from 'react';

export const AppAppearanceContext = createContext();

export const AppAppearanceProvider = props => {
  const { children, ...rest } = props;
  return <AppAppearanceContext.Provider value={rest}>{children}</AppAppearanceContext.Provider>;
};
